import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICommentsDatasource } from '../../../../comments/datasources/comments_datasource';
import { ApStudentDetailsModel } from '../../../../global/components/student_details/models/ap_student_details_model';
import { FeedbackSuggestedPlanModel } from '../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { CommentContentTypeStrategy } from '../strategies/course_flag_content_type_strategy';

angular
  .module('capability-ng-academic-planner')
  .service(
    'createCourseFlagCommand',
    function createCourseFlagCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngCommentsDatasource: ICommentsDatasource,
      log: any
    ) {
      return defineCommandORM(
        'createCourseFlagCommand',
        function createCourseFlagCommand(deferred, courseId: number, message: string) {
          const url = `/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/comment/`;
          const params = {
            content_type: CommentContentTypeStrategy['course'],
            object_id: courseId
          };

          if (!_4.isUndefined(message)) {
            params['message'] = message;
          }

          $http
            .post(url, params)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngCommentsDatasource.put(data);
              deferred.resolve();
            })
            .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
              log.issue('failed to flag the course');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_flag_dialog/commands/create_course_flag_command.ts